import * as React from "react";
import { IconButton, Typography } from "@material-ui/core";
import LogoHeader from "./header/LogoHeader";
import { makeStyles } from "@material-ui/core/styles";
import TenantSelector from "../auth/TenantSelector";
import MenuRoundedIcon from "@material-ui/icons/MenuRounded";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import AccountCircleRoundedIcon from "@material-ui/icons/AccountCircleRounded";
import Popper from "@material-ui/core/Popper";
import { useRef, useState } from "react";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import PowerSettingsNewRoundedIcon from "@material-ui/icons/PowerSettingsNewRounded";
import MenuItem from "@material-ui/core/MenuItem";
import { useIntl } from "react-intl";
import { logoutService } from "../api";
import { SESSION_TOKEN_STORAGE_KEY } from "../utils/constants";

const useStyles = makeStyles((theme) => ({
  loginHeader: {
    backgroundColor: theme.palette.secondary.main,
    display: "flex",
    alignItems: "center",
    paddingRight: theme.spacing(4),
  },
  logoContainer: {
    display: "flex",
    gap: theme.spacing(2),
    flex: 1,
  },
  menuButtonShow: {
    opacity: 1,
    cursor: "pointer",
  },
  menuButtonHide: {
    opacity: 0,
    cursor: "auto",
  },
  userIcon: {
    marginLeft: theme.spacing(2),
  },
}));

const Header = ({ handleOpenMenu, open }) => {
  const classes = useStyles();
  const intl = useIntl();
  const menuRef = useRef();

  const token = sessionStorage.getItem(SESSION_TOKEN_STORAGE_KEY);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleUserMenu = (event) => {
    setAnchorEl(anchorEl ? null : event?.currentTarget);
  };

  const handleLogOut = () => {
    logoutService();
  };

  return (
    <div className={classes.loginHeader}>
      <div className={classes.logoContainer}>
        <IconButton
          disabled={!token}
          className={!!token ? classes.menuButtonShow : classes.menuButtonHide}
          onClick={handleOpenMenu}
        >
          {open ? (
            <CloseRoundedIcon color={"primary"} fontSize={"large"} />
          ) : (
            <MenuRoundedIcon color={"primary"} fontSize={"large"} />
          )}
        </IconButton>
        <LogoHeader />
      </div>
      {!!token && (
        <>
          <div>
            <TenantSelector />
          </div>
          <div className={classes.userIcon}>
            <IconButton ref={menuRef} onClick={handleUserMenu}>
              <AccountCircleRoundedIcon color={"primary"} fontSize={"large"} />
            </IconButton>
            <Popper
              open={!!anchorEl}
              anchorEl={anchorEl}
              role={undefined}
              transition
              disablePortal
              placement={"bottom-end"}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleUserMenu}>
                  <MenuItem onClick={handleLogOut}>
                    <ListItemIcon>
                      <PowerSettingsNewRoundedIcon />
                    </ListItemIcon>
                    <Typography>{intl.formatMessage({ id: "ra.auth.logout" })}</Typography>
                  </MenuItem>
                </ClickAwayListener>
              </Paper>
            </Popper>
          </div>
        </>
      )}
    </div>
  );
};

export default Header;
